import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown, X, Mail, BookOpen } from 'lucide-react';
import catalogueStructure from '../data/catalogueStructure';
import { labelForHamburger } from '../data/hamburgerOverrides';
import { useSiteSettings } from '../hooks/useSiteSettings';

function SubcatLinks({ items, parentSlug, onClose }) {
  return (
    <div className="bg-gray-50 py-1">
      <Link to={"/catalogue/" + parentSlug} onClick={onClose}
        className="flex items-center px-8 py-2 text-xs font-medium text-orange-500 hover:bg-orange-100 transition-colors">
        Voir toute la cat&#233;gorie
      </Link>
      {items.map(function(sub) {
        return (
          <Link key={sub.slug} to={"/catalogue/" + parentSlug + "/" + sub.slug} onClick={onClose}
            className="flex items-center gap-3 px-8 py-2.5 hover:bg-white transition-colors">
            <span className="text-lg">{sub.emoji}</span>
            <span className="text-sm text-gray-700">{labelForHamburger(sub)}</span>
          </Link>
        );
      })}
    </div>
  );
}

function SidebarCategory({ cat, expanded, onToggle, onClose }) {
  var btnCls = "w-full flex items-center justify-between px-6 py-3 text-sm transition-colors hover:bg-orange-50 " + (cat.highlight ? "text-orange-600 font-semibold" : "text-gray-700") + (expanded ? " bg-orange-50 text-orange-600" : "");
  var chevCls = "w-4 h-4 transition-transform text-gray-400 " + (expanded ? "rotate-180" : "");

  return (
    <div className="border-b border-gray-50">
      <button onClick={onToggle} className={btnCls}>
        <span className="flex items-center gap-2">
          <span className="text-base">{cat.emoji}</span>
          <span>{cat.name}</span>
        </span>
        <ChevronDown className={chevCls} />
      </button>
      {expanded && <SubcatLinks items={cat.subcategories} parentSlug={cat.slug} onClose={onClose} />}
    </div>
  );
}

function DesktopSidebar({ isOpen, onClose }) {
  var [expanded, setExpanded] = useState('');
  var settings = useSiteSettings();

  if (!isOpen) return null;

  function toggle(slug) {
    setExpanded(expanded === slug ? '' : slug);
  }

  return (
    <div className="hidden lg:block fixed inset-0 z-[60]" data-testid="desktop-sidebar">
      <div className="absolute inset-0 bg-black/30" onClick={onClose}></div>
      <div className="absolute left-0 top-0 bottom-0 w-96 bg-white shadow-2xl overflow-y-auto animate-slide-in-left">
        <div className="flex items-center justify-between px-6 py-5 border-b border-gray-100">
          <span className="text-lg font-bold text-gray-900">Notre Catalogue</span>
          <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-lg transition-colors">
            <X className="w-5 h-5 text-gray-500" />
          </button>
        </div>
        <nav className="py-2">
          <Link to="/catalogue" onClick={onClose} className="flex items-center px-6 py-3 text-sm text-gray-700 hover:bg-orange-50 hover:text-orange-600 transition-colors font-medium border-b border-gray-50">
            Tous les produits
          </Link>
          {catalogueStructure.map(function(cat) {
            return (
              <SidebarCategory
                key={cat.slug}
                cat={cat}
                expanded={expanded === cat.slug}
                onToggle={function() { toggle(cat.slug); }}
                onClose={onClose}
              />
            );
          })}
        </nav>
        <div className="border-t border-gray-100 py-4 px-6">
          <a
            href={settings.catalogueUrlWithoutPrices}
            target="_blank"
            rel="noopener noreferrer"
            onClick={onClose}
            className="flex items-center gap-2 py-3 text-sm text-gray-700 hover:text-orange-600 font-medium"
            data-testid="sidebar-feuilleter-catalogue"
          >
            <BookOpen className="w-4 h-4" /> Feuilleter le catalogue
          </a>
          <Link to="/realisations" onClick={onClose} className="block py-3 text-sm text-gray-700 hover:text-orange-600 font-medium">Nos R&#233;alisations</Link>
          <Link to="/faq" onClick={onClose} className="block py-3 text-sm text-gray-700 hover:text-orange-600 font-medium">FAQ</Link>
          <Link to="/a-propos" onClick={onClose} className="block py-3 text-sm text-gray-700 hover:text-orange-600 font-medium">&#192; Propos</Link>
        </div>
        <div className="px-6 pb-6">
          <Link to="/devis" onClick={onClose} className="flex items-center justify-center gap-2 w-full py-3 bg-orange-500 text-white font-semibold rounded-xl hover:bg-orange-600 transition-colors">
            <Mail className="w-4 h-4" /> Demande de Devis
          </Link>
        </div>
      </div>
    </div>
  );
}

export default DesktopSidebar;
